export default "__VITE_ASSET__CnGIsuSD__"